const SiteActionsConstants = {
    SET_MOBILE: 'SET_MOBILE'
};

export default SiteActionsConstants;
